import { GetterTree } from 'vuex'

import { RootState, PlaceState } from '@/types/store'

export const getters: GetterTree<PlaceState, RootState> = {
  places(state): PlaceState['places'] {
    return state.places
  },
}
